import React from "react";
import { Link } from "react-router-dom";
import { UtensilsCrossed } from "lucide-react";
import LanguageToggle from "@/components/LanguageToggle";

export default function AuthShell({ children, title, subtitle }) {
  return (
    <div className="min-h-screen relative z-10 flex flex-col">
      <header className="px-4 h-16 flex items-center justify-between max-w-2xl w-full mx-auto">
        <Link to="/" className="flex items-center gap-2" data-testid="auth-brand">
          <span className="w-10 h-10 rounded-xl bg-thali-green text-white grid place-items-center shadow-btn-green"><UtensilsCrossed className="w-5 h-5" /></span>
          <span className="font-heading font-extrabold text-thali-green text-lg">PM POSHAN</span>
        </Link>
        <LanguageToggle />
      </header>
      <main className="flex-1 flex items-start justify-center px-4 py-6">
        <div className="w-full max-w-md">
          <div className="text-center mb-5 animate-fade-in-up">
            <h1 className="text-2xl md:text-3xl font-heading font-extrabold text-thali-ink">{title}</h1>
            {subtitle && <p className="text-thali-ink/60 mt-1 text-sm">{subtitle}</p>}
          </div>
          <div className="card-thali animate-fade-in-up" style={{ animationDelay: "80ms" }}>{children}</div>
        </div>
      </main>
    </div>
  );
}
